import React, { useEffect } from "react";
//outsource
import { Select } from "antd";
//components

//redux
import { useDispatch, useSelector } from "react-redux";
import {
  snapBranchs,
  unSnapBranchs,
} from "../../../../store/branch/branch.action";
import { setCompanyName } from "../../../../store/report/report.action";
import { branchsSelector } from "../../../../store/branch/branch.selector";

const TimeBranchSelect = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branchs = useSelector(branchsSelector);
  //   console.log({ branchs });
  // -------------------------- FUNCTION --------------------------
  const handleSelect = (value) => {
    dispatch(setCompanyName({ data: value }));
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(snapBranchs());
    return () => dispatch(unSnapBranchs());
  }, [dispatch]);
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  const options = refineOption(branchs);
  return (
    <Select
      style={{ width: "100%" }}
      options={options}
      placeholder="Select Branch"
      clearIcon
      showSearch
      onSelect={handleSelect}
    />
  );
};

export default TimeBranchSelect;

const refineOption = (data) => {
  const newData = data?.map((item) => {
    const value = item?.id;
    const label = item?.name;
    return {
      value,
      label,
    };
  });
  return newData;
};
